import { PartialField } from '@niaratech/devcase-crud/dist/fillCrudMetadataGaps';
import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import { type Tenant } from '../../types';
export default fillCrudMetadataGaps({
  label: 'Regra de fluxo de reserva',
  labelPlural: 'Regras de fluxo de reserva',
  deletable: false,
  name: 'CheckoutFlowRule',
  namePlural: 'CheckoutFlowRules',
  custom_withAudit: true,
  custom_blockRecord: true,
  authorization: authorization('clientConsultant', 'admin'),
  dynamoDB: {
    tableName: 'SpearCheckoutFlowRule'
  },
  columns: ['id', 'name', 'enabled'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'name',
    label: 'Título',
    type: 'text',
    required: true
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: true,
    type: 'boolean',
    required: true
  }, {
    name: 'allowBookingWithoutPaymentForUnauthenticated',
    default: 'NEVER',
    options: [{
      value: 'NEVER',
      label: 'Paga primeiro e reserva depois'
    }, {
      value: 'LOW_RISK',
      label: 'Reembolsável:Reserva primeiro e paga depois / Em Penalidade: Paga primeiro e reserva depois'
    }, {
      value: 'ALWAYS',
      label: 'Reserva primeiro e paga depois'
    }],
    required: true,
    label: 'Fluxo reserva (B2C)',
    custom_groupName: 'Fluxo de Checkout'
  }, {
    name: 'allowBookingWithoutPaymentForClient',
    default: 'LOW_RISK',
    options: [{
      value: 'NEVER',
      label: 'Paga primeiro e reserva depois'
    }, {
      value: 'LOW_RISK',
      label: 'Reembolsável:Reserva primeiro e paga depois / Em Penalidade: Paga primeiro e reserva depois'
    }, {
      value: 'ALWAYS',
      label: 'Reserva primeiro e paga depois'
    }],
    required: true,
    label: 'Fluxo reserva (B2B)',
    custom_groupName: 'Fluxo de Checkout'
  }, {
    name: 'allowBookingWithoutPaymentForInstallation',
    default: 'ALWAYS',
    options: [{
      value: 'NEVER',
      label: 'Paga primeiro e reserva depois'
    }, {
      value: 'LOW_RISK',
      label: 'Reembolsável:Reserva primeiro e paga depois / Em Penalidade: Paga primeiro e reserva depois'
    }, {
      value: 'ALWAYS',
      label: 'Reserva primeiro e paga depois'
    }],
    required: true,
    label: 'Fluxo reserva (Instalação)',
    custom_groupName: 'Fluxo de Checkout'
  }, {
    name: 'allowBookingWithoutPaymentForApi',
    default: 'NEVER',
    options: [{
      value: 'NEVER',
      label: 'Paga primeiro e reserva depois'
    }],
    required: true,
    label: 'Fluxo reserva (API)',
    custom_groupName: 'Fluxo de Checkout'
  }, {
    name: 'shoppingCartEnabled',
    label: 'Carrinho de compras habilitado',
    default: false,
    type: 'boolean',
    custom_groupName: 'Carrinho de compras'
  }, {
    name: 'shoppingCartMaxItemCount',
    label: 'Máximo de itens do carrinho',
    hint: 'Válido apenas para reservas de hotel.',
    default: null,
    type: 'int',
    custom_groupName: 'Carrinho de compras'
  }, {
    name: 'backofficeNotificationEvent',
    label: 'Envio automático',
    default: 'NEVER',
    inputType: 'select',
    options: [{
      label: 'Quando há uma reserva confirmada',
      value: 'CONFIRMED'
    }, {
      label: 'Após confirmação de recebimento e/ou após recebimento faturado registrado',
      value: 'PAYMENT'
    }, {
      label: 'Nunca',
      value: 'NEVER'
    }],
    custom_groupName: 'Notificações de Backoffice'
  }, {
    label: 'Fluxo de Reserva (B2B)',
    name: 'b2b_modules_forGroups_v2',
    custom_groupName: 'Fluxo de Reserva para Grupos',
    type: 'boolean',
    hint: 'Este tipo de usuário terá acesso ao fluxo de reserva e a visualização.',
    custom_checkTenant: (t: Tenant) => t?.modules_forGroups_v2
  }, {
    label: 'Fluxo para B2C (Usuário final)',
    name: 'b2cChangeFlow',
    custom_groupName: 'Ações manuais do usuário',
    type: 'textarray',
    options: [{
      value: 'BLOCK_B2C_CANCELLATION',
      label: 'Cancelamento da Reserva/Viagem: Usuário B2C não poderá fazer nenhum tipo de cancelamento na reserva'
    }]
  }, {
    label: 'Fluxo para B2B (Usuário de cliente)',
    name: 'b2bChangeFlow',
    custom_groupName: 'Ações manuais do usuário',
    type: 'textarray',
    options: [{
      value: 'BLOCK_B2B_CHANGE_FLOW',
      label: 'Alteração de Reserva: Usuário de cliente não poderá fazer nenhum tipo de alteração na reserva'
    }, {
      value: 'BLOCK_B2B_CANCELLATION',
      label: 'Cancelamento da Reserva/Viagem: Usuário de cliente não poderá fazer nenhum tipo de cancelamento na reserva'
    }]
  }, {
    label: 'Fluxo para Instalação',
    name: 'tenantChangeFlow',
    custom_groupName: 'Ações manuais do usuário',
    type: 'textarray',
    options: [{
      value: 'BLOCK_TENANT_CHANGE_FLOW',
      label: 'Alteração de Reserva: Usuário da instalação não poderá fazer nenhum tipo de alteração na reserva'
    }]
  }, {
    label: 'Opções de envio automático no comentário',
    name: 'autoSubmitOptionsInComment',
    type: 'textarray',
    custom_groupName: 'Campos de envio automático no comentário',
    inputType: 'niara-react-form/inputMultiSelect',
    withOptionSorter: true,
    options: [{
      label: 'Responsável da reserva',
      value: 'RESPONSIBLE_USER_FOR_RESERVATION'
    }, {
      label: 'Criador da reserva',
      value: 'RESERVATION_CREATOR'
    }]
  }, {
    custom_groupName: 'Criação de Contrato no Checkout',
    label: 'Credencial de Contrato',
    name: 'esignatureCredentialId',
    inputType: 'credential',
    credentialTypeList: ['CLSG']
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Credencial do Serasa',
    name: 'serasaCredentialId',
    inputType: 'credential',
    credentialTypeList: ['SERA']
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Verificar Score Mínimo',
    name: 'serasaMinimumScoreEnabled',
    type: 'boolean'
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Valor mínimo do Score',
    name: 'serasaMinimumScore',
    type: 'int'
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Verificar Débito Máximo',
    name: 'serasaMaximumDebtEnabled',
    type: 'boolean'
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Valor máximo de débito',
    name: 'serasaMaximumDebt',
    type: 'int'
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Verificar situação regular dos documentos',
    name: 'serasaStatusRegistrationEnabled',
    type: 'boolean'
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Validade da última consulta (dias)',
    name: 'serasaReportValidityDays',
    type: 'int'
  }, {
    custom_groupName: 'Verificação no Serasa no Checkout',
    label: 'Mensagem de erro em caso de recusa.',
    name: 'serasaErrorMessage'
  }] as Array<PartialField>,
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq',
    label: 'Ativo'
  }]
});